module.exports = __webpack_public_path__ + "img/google.a392e807.svg";